export const START_SCREEN_SESSION_STORAGE_KEY = 'variant_trial_start_screen_shown';

let shownForUserId: null | string = null;

export const hasShownStartScreen = (userId: string) => {
  if (shownForUserId === userId) return true;

  try {
    return sessionStorage.getItem(START_SCREEN_SESSION_STORAGE_KEY) === userId;
  } catch {
    return false;
  }
};

export const markStartScreenShown = (userId: string) => {
  shownForUserId = userId;

  try {
    sessionStorage.setItem(START_SCREEN_SESSION_STORAGE_KEY, userId);
  } catch {
    /* no-op: storage unavailable, the in-memory flag covers this page load */
  }
};

export const clearStartScreenShown = () => {
  shownForUserId = null;

  try {
    sessionStorage.removeItem(START_SCREEN_SESSION_STORAGE_KEY);
  } catch {
    /* no-op: storage unavailable */
  }
};
